<template>
  <el-card class="h-100 position-absolute" id="smallMap">
    <!-- 表头 -->
    <div slot="header">
      <el-row type="flex" align="middle">
        <el-col :span="18">小地图</el-col>
        <el-col :span="6" class="tr">
          <el-tooltip :content="'关闭小地图'" :open-delay="1000">
            <span class="iconfont icon-close cur-pointer" @click="closeMap(false)"></span>
          </el-tooltip>
        </el-col>
      </el-row>
    </div>
    <!-- 地图操作集合 -->
    <div class="fz-12">
      <div class="flex m-t-10 form-box">
        <span>小地图：</span>
        <el-switch
          v-model="openMapSwitch"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
      </div>
      <div class="flex m-t-10 form-box">
        <div style="width: 64px">地图大小：</div>
        <el-input-number
          size="small"
          v-model="wMap"
          @change="MapChange('x', arguments)"
          :min="0.01"
          :max="500"
          placeholder="宽"
        ></el-input-number>
        <el-input-number
          size="small"
          v-model="hMap"
          @change="MapChange('y', arguments)"
          :min="0.01"
          :max="500"
          placeholder="高"
        ></el-input-number>
      </div>
      <div class="flex m-t-10 form-box">
        <div style="width: 64px">地图缩放：</div>
        <el-input-number
          size="small"
          v-model="wParam"
          @change="widthChange"
          :min="0.01"
          :max="100"
          :step="0.02"
          placeholder="比例"
        ></el-input-number>
      </div>
      <div class="flex m-t-10 form-box">
        <span>视角方向：</span>
        <el-select
          size="small"
          clearable
          v-model="angle"
          @change="angleChange"
          placeholder="请选择"
        >
          <el-option
            v-for="item in angleOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex m-t-10 form-box">
        <span>地图位置：</span>
        <el-select
          size="small"
          clearable
          @change="locationChange"
          v-model="location"
          placeholder="请选择"
        >
          <el-option
            v-for="item in locationOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'samllMap',
  data() {
    return {
      wMap: 380, // 地图宽度
      hMap: 210, // 地图高度
      wParam: 1, // 内容宽度和高度缩放
      angle: '上', // 视角方向
      openMapSwitch: false, // 地图全景图开关
      location: '右上角', // 位置
      angleOptions: ['上', '下', '左', '右'],
      locationOptions: ['左上角', '左下角', '右上角', '右下角'],
    }
  },
  props: {
    isOpenMap: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    // 根据player中的配置设置初始值
    const default_openMapSwitch = await window.player.Native.Settings.get('panorama.show')
    this.openMapSwitch = default_openMapSwitch.value
    const default_location = await window.player.Native.Settings.get('map.pos')
    this.location = default_location.value
    const default_angle = await window.player.Native.Settings.get('map.dir')
    this.angle = default_angle.value
    const default_wMap = await window.player.Native.Settings.get('map.size.x')
    this.wMap = default_wMap.value
    const default_hMap = await window.player.Native.Settings.get('map.size.y')
    this.hMap = default_hMap.value
    const default_wParam = await window.player.Native.Settings.get('map.scale.x')
    this.wParam = default_wParam.value
  },
  watch: {
    openMapSwitch(val) {
      // 打开或者关闭地图
      window.player.Native.Settings.set('panorama.show', 'bool', val)
    },
  },
  methods: {
    closeMap(val) {
      this.$emit('changeMap', val)
    },
    locationChange(val) {
      // 设置位置
      this.player.Native.Settings.set('map.pos', 'stringList', val)
    },
    angleChange(val) {
      // 设置方向
      this.player.Native.Settings.set('map.dir', 'stringList', val)
    },
    widthChange(val) {
      // 设置缩放
      window.player.Native.Settings.set('map.scale.x', 'double', val)
      window.player.Native.Settings.set('map.scale.y', 'double', val)
    },
    MapChange(type, val) {
      window.player.Native.Settings.set(`map.size.${type}`, 'int', val[0])
      // 设置地图大小
      console.log(type, val)
    },
  },
}
</script>

<style lang="scss" scoped>

#smallMap {
  height: 290px;
  width: 350px;
  left: 6px;
  top: 44px;
  box-shadow: 0px 0px 1px 4px #dcdbdb91;
  border-radius: 4px;
  z-index: 99;
  .form-box {
    align-items: center;
  }
}

</style>
